import React from 'react'
import { FiArrowLeft, FiCompass, FiHeart, FiMic } from 'react-icons/fi'
import AnimatedBrandMark from '../AnimatedBrandMark'
import './appComingSoon.css'

const experienceSignals = [
  {
    id: 'presence',
    Icon: FiCompass,
    labelFr: 'Entrez dans une histoire',
    labelEn: 'Step inside a story',
  },
  {
    id: 'voice',
    Icon: FiMic,
    labelFr: 'Parlez pour avancer',
    labelEn: 'Speak to move forward',
  },
  {
    id: 'memory',
    Icon: FiHeart,
    labelFr: 'Retrouvez vos réflexes',
    labelEn: 'Rediscover your instincts',
  },
]

const particles = [
  [7, 18, 0.72, 8.4, -2.1],
  [15, 73, 0.45, 11.2, -7.5],
  [24, 37, 0.68, 9.7, -4.4],
  [34, 84, 0.52, 12.8, -9.2],
  [46, 12, 0.42, 10.5, -1.3],
  [57, 67, 0.75, 8.8, -5.6],
  [66, 25, 0.5, 13.4, -10.1],
  [75, 88, 0.62, 9.2, -3.8],
  [84, 43, 0.45, 11.7, -8.3],
  [93, 16, 0.68, 10.1, -6.4],
  [11, 92, 0.4, 12.1, -4.7],
  [89, 72, 0.55, 9.9, -2.9],
]

const AppComingSoon = () => (
  <main className="app-coming-soon" id="app" lang="fr" tabIndex="-1">
    <div className="app-coming-soon__ambient" aria-hidden="true">
      <span className="app-coming-soon__grid" />
      <span className="app-coming-soon__glow app-coming-soon__glow--gold" />
      <span className="app-coming-soon__glow app-coming-soon__glow--blue" />
      <span className="app-coming-soon__horizon" />
      {particles.map(([left, top, opacity, duration, delay], index) => (
        <i
          className="app-coming-soon__particle"
          key={`${left}-${top}`}
          style={{
            '--particle-left': `${left}%`,
            '--particle-top': `${top}%`,
            '--particle-opacity': opacity,
            '--particle-duration': `${duration}s`,
            '--particle-delay': `${delay}s`,
            '--particle-size': `${2 + (index % 3)}px`,
          }}
        />
      ))}
    </div>

    <section className="app-coming-soon__hero" aria-labelledby="app-coming-soon-title">
      <div className="app-coming-soon__copy">
        <p className="app-coming-soon__eyebrow">
          <span aria-hidden="true"><i /></span>
          <span lang="fr">Expérience OctoSynapse · En création</span>
          <small lang="en">OctoSynapse experience · In the making</small>
        </p>

        <h1 id="app-coming-soon-title">
          <span lang="fr">
            Votre langue est sur le point
            {' '}
            <strong>de se réveiller.</strong>
          </span>
          <small lang="en">
            Your language is about to
            {' '}
            <em>wake up.</em>
          </small>
        </h1>

        <div className="app-coming-soon__intro">
          <p lang="fr">
            Nous développons une expérience immersive où la mémoire, la voix et
            l’action se rencontrent. Elle n’est pas encore prête à vous accueillir —
            mais elle arrive.
          </p>
          <p lang="en">
            We are building an immersive experience where memory, voice and action
            come together. It is not quite ready to welcome you yet—but it is coming.
          </p>
        </div>

        <div className="app-coming-soon__status">
          <span className="app-coming-soon__status-signal" aria-hidden="true"><i /></span>
          <p>
            <strong lang="fr">Une expérience extraordinaire se prépare.</strong>
            <small lang="en">An extraordinary experience is taking shape.</small>
          </p>
          <span className="app-coming-soon__status-pill">
            <span lang="fr">Bientôt disponible</span>
            <small lang="en">Coming soon</small>
          </span>
        </div>

        <ul className="app-coming-soon__signals" aria-label="Aperçu de l’expérience / Experience preview">
          {experienceSignals.map(({ id, Icon, labelFr, labelEn }, index) => (
            <li key={id} style={{ '--signal-index': index }}>
              <span aria-hidden="true"><Icon /></span>
              <p>
                <strong lang="fr">{labelFr}</strong>
                <small lang="en">{labelEn}</small>
              </p>
            </li>
          ))}
        </ul>

        <a className="app-coming-soon__back" href="#home">
          <FiArrowLeft aria-hidden="true" />
          <span>
            <span lang="fr">En attendant, découvrez notre univers</span>
            <small lang="en">Meanwhile, explore our world</small>
          </span>
        </a>
      </div>

      <figure className="app-coming-soon__stage">
        <div className="app-coming-soon__portal" aria-hidden="true">
          <span className="app-coming-soon__portal-aura" />
          <span className="app-coming-soon__portal-ring app-coming-soon__portal-ring--outer" />
          <span className="app-coming-soon__portal-ring app-coming-soon__portal-ring--middle" />
          <span className="app-coming-soon__portal-ring app-coming-soon__portal-ring--inner" />
          <span className="app-coming-soon__portal-scan" />

          <svg
            className="app-coming-soon__network"
            viewBox="0 0 520 520"
            focusable="false"
          >
            <g className="app-coming-soon__network-paths">
              <path d="M260 260 C190 226 157 157 98 118" pathLength="1" />
              <path d="M260 260 C326 219 361 149 426 120" pathLength="1" />
              <path d="M260 260 C187 292 147 361 78 385" pathLength="1" />
              <path d="M260 260 C324 304 362 367 440 393" pathLength="1" />
              <path d="M260 260 C262 185 268 129 260 65" pathLength="1" />
              <path d="M260 260 C258 337 252 395 266 456" pathLength="1" />
            </g>
            <g className="app-coming-soon__network-nodes">
              <circle cx="98" cy="118" r="4" />
              <circle cx="426" cy="120" r="4" />
              <circle cx="78" cy="385" r="4" />
              <circle cx="440" cy="393" r="4" />
              <circle cx="260" cy="65" r="4" />
              <circle cx="266" cy="456" r="4" />
            </g>
          </svg>

          <span className="app-coming-soon__mark octo-brand-owner">
            <span className="app-coming-soon__mark-halo" />
            <AnimatedBrandMark variant="experience" />
          </span>

          <span className="app-coming-soon__portal-label app-coming-soon__portal-label--memory">
            <i /> mémoire <small>memory</small>
          </span>
          <span className="app-coming-soon__portal-label app-coming-soon__portal-label--voice">
            <i /> voix <small>voice</small>
          </span>
          <span className="app-coming-soon__portal-label app-coming-soon__portal-label--emotion">
            <i /> émotion <small>emotion</small>
          </span>
        </div>

        <figcaption className="app-coming-soon__stage-caption">
          <span className="app-coming-soon__stage-kicker">OCTOSYNAPSE · 01</span>
          <p>
            <strong lang="fr">Le portail s’ouvre bientôt.</strong>
            <small lang="en">The portal opens soon.</small>
          </p>
          <div className="app-coming-soon__progress">
            <span><i /></span>
            <small>
              <span lang="fr">Signal en construction</span>
              <span lang="en">Signal under construction</span>
            </small>
          </div>
        </figcaption>
      </figure>
    </section>

    <footer className="app-coming-soon__footer">
      <span aria-hidden="true" />
      <p>
        <span lang="fr">La prochaine histoire sera la vôtre.</span>
        <small lang="en">The next story will be yours.</small>
      </p>
      <span aria-hidden="true" />
    </footer>
  </main>
)

export default AppComingSoon
